export default __webpack_public_path__ + "static/media/icon-empty-kb.5b7b7e55.svg";